export const main = {
    state: {
        arrivalDate: null,
        departureDate: null,
        numberOfPersons: 0,
        adults: 2,
        children: 0,
        babies: 0,
        personalInfo: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            birthDate: '',
            street: '',
            houseNumber: '',
            addition: '',
            postalCode: '',
            city: '',
            country: '',
        },
        numberOfNights: 0,
        stayCost: 0,
        totalCost: 0,
        options: [],
        poolHeatingDays: 0,
        poolHeatingPrice: 50, // Add the price per day for pool heating
        intermediateCleaningTimes: 0,
        intermediateCleaningPrice: 30, // Add the price per intermediate cleaning
        cleaningCost: 100, // Fixed cleaning cost
    },
    mutations: {
        setArrivalDate(state, date) {
            state.arrivalDate = date;
        },
        setDepartureDate(state, date) {
            state.departureDate = date;
        },
        setNumberOfPersons(state, persons) {
            state.numberOfPersons = persons;
        },
        setAdults(state, adults) {
            state.adults = adults;
        },
        setChildren(state, children) {
            state.children = children;
        },
        setBabies(state, babies) {
            state.babies = babies;
        },
        setPersonalInfo(state, { field, value }) {
            state.personalInfo[field] = value;
        },
        setNumberOfNights(state, nights) {
            state.numberOfNights = nights;
        },
        setStayCost(state, cost) {
            state.stayCost = cost;
        },
        setTotalCost(state, cost) {
            state.totalCost = cost;
        },
        addOption(state, option) {
            state.options.push(option);
        },
        updateOption(state, updatedOption) {
            const index = state.options.findIndex(option => option.id === updatedOption.id);
            if (index !== -1) {
                state.options.splice(index, 1, updatedOption);
            }
        },
        removeOption(state, optionId) {
            state.options = state.options.filter(option => option.id !== optionId);
        },
        setPoolHeatingDays(state, days) {
            state.poolHeatingDays = days;
            const poolHeatingOption = {
                id: 'poolHeating',
                name: 'Zwembadverwarming',
                price: days * state.poolHeatingPrice
            };
            const index = state.options.findIndex(option => option.id === 'poolHeating');
            if (days > 0) {
                if (index === -1) {
                    state.options.push(poolHeatingOption);
                } else {
                    state.options.splice(index, 1, poolHeatingOption);
                }
            } else if (index !== -1) {
                state.options.splice(index, 1);
            }
        },
        setIntermediateCleaningTimes(state, times) {
            state.intermediateCleaningTimes = times;
            const cleaningOption = {
                id: 'intermediateCleaning',
                name: 'Extra schoonmaak',
                price: times * state.intermediateCleaningPrice
            };
            const index = state.options.findIndex(option => option.id === 'intermediateCleaning');
            if (times > 0) {
                if (index === -1) {
                    state.options.push(cleaningOption);
                } else {
                    state.options.splice(index, 1, cleaningOption);
                }
            } else if (index !== -1) {
                state.options.splice(index, 1);
            }
        },
    },
    actions: {
        updateArrivalDate({ commit, dispatch }, date) {
            commit('setArrivalDate', date);
            dispatch('calculateNumberOfNights');
        },
        updateDepartureDate({ commit, dispatch }, date) {
            commit('setDepartureDate', date);
            dispatch('calculateNumberOfNights');
        },
        updateNumberOfPersons({ commit }, persons) {
            commit('setNumberOfPersons', persons);
        },
        updateAdults({ commit }, adults) {
            commit('setAdults', adults);
        },
        updateChildren({ commit }, children) {
            commit('setChildren', children);
        },
        updateBabies({ commit }, babies) {
            commit('setBabies', babies);
        },
        updatePersonalInfo({ commit }, info) {
            commit('setPersonalInfo', info);
        },
        calculateNumberOfNights({ state, commit, dispatch }) {
            if (state.arrivalDate && state.departureDate) {
                const arrival = new Date(state.arrivalDate);
                const departure = new Date(state.departureDate);
                const timeDifference = Math.abs(departure - arrival);
                const nights = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
                commit('setNumberOfNights', nights);
                dispatch('calculateCosts');
            } else {
                commit('setNumberOfNights', 0);
                dispatch('calculateCosts');
            }
        },
        calculateCosts({ state, commit }) {
            const stayCost = state.numberOfNights * state.pricePerNight;
            const optionsCost = state.options.reduce((total, option) => total + option.price, 0);
            const poolHeatingCost = state.poolHeatingDays * state.poolHeatingPrice;
            const intermediateCleaningCost = state.intermediateCleaningTimes * state.intermediateCleaningPrice;
            const totalCost = stayCost + state.cleaningCost + optionsCost + poolHeatingCost + intermediateCleaningCost;
            commit('setStayCost', stayCost);
            commit('setTotalCost', totalCost);
        },
        addOption({ commit }, option) {
            commit('addOption', option);
        },
        updateOption({ commit }, updatedOption) {
            commit('updateOption', updatedOption);
        },
        removeOption({ commit }, optionId) {
            commit('removeOption', optionId);
        },
        updatePoolHeatingDays({ commit, dispatch }, days) {
            commit('setPoolHeatingDays', days);
            dispatch('calculateCosts');
        },
        updateIntermediateCleaningTimes({ commit, dispatch }, times) {
            commit('setIntermediateCleaningTimes', times);
            dispatch('calculateCosts');
        },
    },
    getters: {
        getArrivalDate: state => state.arrivalDate,
        getDepartureDate: state => state.departureDate,
        getNumberOfPersons: state => state.numberOfPersons,
        getAdults: state => state.adults,
        getChildren: state => state.children,
        getBabies: state => state.babies,
        getPersonalInfo: state => state.personalInfo,
        getNumberOfNights: state => state.numberOfNights,
        getStayCost: state => state.stayCost,
        getTotalCost: state => state.totalCost,
        getOptions: state => state.options,
        getPoolHeatingDays: state => state.poolHeatingDays,
        getIntermediateCleaningTimes: state => state.intermediateCleaningTimes,
        getCleaningCost: state => state.cleaningCost, // Getter for cleaning cost
    }
};
